import { render, staticRenderFns } from "./taskDetial.vue?vue&type=template&id=4c98c60e&scoped=true&"
import script from "./taskDetial.vue?vue&type=script&lang=js&"
export * from "./taskDetial.vue?vue&type=script&lang=js&"
import style0 from "./taskDetial.vue?vue&type=style&index=0&id=4c98c60e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c98c60e",
  null
  
)

export default component.exports